<template>
  <transition 
    name="modal"
    appear
  >
    <div class="modal">
      <div class="modal__window modal__window--type01">
        <!-- 모달 헤드(top) -->
        <div class="modal__head">
          <h1 class="title">
            고객문의
          </h1>
        </div>
        <!-- 모달 컨텐츠 -->
        <form
          ref="form"
          @submit.prevent="checkForm"
        >
          <div 
            v-if="!isSuccess"
            class="modal__contents"
          >
            <div class="formfield formfield--fluid">
              <ul class="formfield__row">
                <li class="formfield__inputitem">
                  <label 
                    class="formfield__label formfield__label--required" 
                    for="name"
                  >
                    성함
                  </label>                
                  <div class="formfield__inputbox formfield__inputbox--block">
                    <input 
                      id="name"
                      v-model.trim="inquiry.name"
                      class="formfield__input" 
                      type="text"
                      autocomplete="username"
                      required="required"
                    >
                    <button
                      v-show="inquiry.name"
                      class="formfield__clear"
                      type="button"
                      @click="clearInput('name')"
                    />
                  </div>
                </li>
                <li class="formfield__inputitem">
                  <label 
                    class="formfield__label formfield__label--required" 
                    for="company"
                  >
                    소속 회사명
                  </label>                
                  <div class="formfield__inputbox formfield__inputbox--block">
                    <input
                      id="company"
                      v-model.trim="inquiry.company"
                      class="formfield__input"
                      type="text"
                      autocomplete="organization"
                      required="required"
                    >
                    <!-- input에 입력했을 때  "formfield__clearbutton" display:block-->
                    <button
                      v-show="inquiry.company"
                      class="formfield__clear"
                      type="button"
                      @click="clearInput('company')"
                    />
                  </div>
                </li>
                <li class="formfield__inputitem">
                  <label 
                    class="formfield__label formfield__label--required" 
                    for="email"
                  >
                    이메일 주소
                  </label>                
                  <div class="formfield__inputbox formfield__inputbox--block">
                    <input
                      id="email"
                      v-model.trim="inquiry.email"
                      class="formfield__input"
                      type="email"
                      autocomplete="email"
                      required="required"
                    >
                    <button
                      v-show="inquiry.email"
                      class="formfield__clear"
                      type="button"
                      @click="clearInput('email')"
                    />
                  </div>
                </li>
              </ul>
              <div class="formfield__row">
                <div class="formfield__inputitem formfield__inputitem--fluid">
                  <label 
                    class="formfield__label formfield__label--required" 
                    for="contents"
                  >
                    문의내용
                  </label>
                  <div class="formfield__inputbox formfield__inputbox--block formfield__inputbox--textarea">                
                    <textarea
                      id="textarea"
                      v-model.trim="inquiry.message"
                      class="formfield__input formfield__input--textarea"
                      cols="25"
                      row="8"
                      name="textarea"
                      autocomplete="off"
                      required="required"
                    />
                  </div>
                </div>            
              </div>
            </div>
          </div>
          <Success
            v-if="isSuccess"
          />
          <!-- 모달 푸터(bottom) -->
          <div
            class="modal__footer"
          >
            <ul class="modal__buttons">     
              <li class="modal__buttonitem">
                <button
                  v-if="isSuccess"
                  type="button"
                  class="button button--large"
                  @click="closeModal('inquiry')"
                >
                  닫기
                </button>
                <button
                  v-else
                  type="submit"
                  class="button button--large"
                  :disabled="!inquiry.company || !inquiry.name || !inquiry.email || !inquiry.message"
                >
                  보내기
                </button>
              </li>
            </ul>
          </div>
        </form>
        <!-- 모달 닫기 버튼 -->
        <div class="modal__close">
          <button 
            class="button button--function" 
            @click="closeModal('inquiry')"
          >
            <span class="hide">닫기</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import axios from 'axios'
import Success from '@/views/inquiry/Success'
export default{
  name:'Inquiry',
  components: {
    Success
  },
  data(){
    return{
      inquiry: {},
      isSuccess: false
    }
  },
  created() {
    this.isSuccess = false
  },
  methods:{
    closeModal(target) {
      this.$store.commit('modalOff', target)
    },
    checkForm(e) {
      axios.post('/v3/inquiry', this.inquiry)
        .then(response => {
          if (response.data.status) {
            this.isSuccess = true
          }
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {})
    },
    clearInput(target) {
      this.inquiry[target] = ''
    },
    request() {
      
    }
  },
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;
  &__buttons{
    width:160px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
.formfield{
  $self:&;
  &__row{
  width:100%;  
  &:not(:first-child){
    padding-top:15px;
  }
}
  &__inputitem{
    float:left;
    width:240px;    
    &:not(:first-child){
      margin-left:10px;
    }
    &--fluid{
      width:740px;
      height:auto;
    }
  }
}
</style>